(function () {
  function tryPlay(video) {
    video.muted = true;
    video.playsInline = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise
        .then(function () {
          if (video.poster) {
            video.removeAttribute('poster');
          }
        })
        .catch(function () {});
    }
  }

  function bootVideos() {
    document.querySelectorAll('.plz-hero-video__video').forEach(function (video) {
      if (video.readyState >= 2) {
        tryPlay(video);
      } else {
        video.addEventListener(
          'loadeddata',
          function () {
            tryPlay(video);
          },
          { once: true }
        );
      }
    });
  }

  function getHeaderScrollOffset() {
    var cssValue = getComputedStyle(document.documentElement).getPropertyValue('--plz-header-offset').trim();
    if (cssValue) {
      var parsed = parseFloat(cssValue);
      if (!isNaN(parsed) && parsed > 0) return Math.ceil(parsed);
    }

    var announcement = document.querySelector('.plz-announcement-bar-section');
    var header = document.querySelector('.plz-header-section');
    var bottom = 0;

    [announcement, header].forEach(function (el) {
      if (!el) return;
      var rect = el.getBoundingClientRect();
      if (rect.height > 0) bottom = Math.max(bottom, rect.bottom);
    });

    return bottom > 0 ? Math.ceil(bottom) : 72;
  }

  function scrollToSection(section) {
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var offset = getHeaderScrollOffset();
    var top = section.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({
      top: Math.max(0, top),
      behavior: reducedMotion ? 'auto' : 'smooth',
    });
  }

  function bootScroll() {
    document.querySelectorAll('.plz-hero-video__scroll').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var wrapper = btn.closest('.plz-hero-video-section') || btn.closest('[id^="shopify-section-"]');
        var next = wrapper && wrapper.nextElementSibling;

        if (!next) return;

        scrollToSection(next);
      });
    });
  }

  function bootScrollVisibility() {
    var scrollBtn = document.querySelector('.plz-hero-video__scroll');
    var headerChrome = document.querySelector('.shopify-section-group-header-group');
    if (!scrollBtn || !headerChrome) return;

    var ticking = false;

    function update() {
      ticking = false;
      var headerBottom = headerChrome.getBoundingClientRect().bottom;
      var btnTop = scrollBtn.getBoundingClientRect().top;
      scrollBtn.classList.toggle('is-behind-header', btnTop < headerBottom + 8);
    }

    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      },
      { passive: true }
    );

    window.addEventListener('resize', update);
    update();
  }

  function boot() {
    bootVideos();
    bootScroll();
    bootScrollVisibility();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    bootVideos();
  });
})();
